import { v4 as uuidv4 } from 'uuid'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { MedicaoAnteriorModel } from '../model-medicoes'
import { MedicaoAnteriorAntropometriaFormModel, MEDICOES_ANTROPOMETRIA } from './model-medicaoAnteriorAntropometria'

export function convertMedicaoAnteriorAntropometriaFormModelToMedicaoAnteriorModel(
  medicao: MedicaoAnteriorAntropometriaFormModel
): MedicaoAnteriorModel {
  return {
    id: uuidv4(),
    altura: medicao.altura,
    data: medicao.data,
    perimetroCefalico: medicao.perimetroCefalico,
    peso: medicao.peso,
  }
}

export function isMedicaoAnteriorAntropometria(medicaoAnterior: HistoricoMedicaoModel): boolean {
  return MEDICOES_ANTROPOMETRIA.some((medicaoAntropometria) => medicaoAnterior[medicaoAntropometria])
}
